module.exports = __webpack_public_path__ + "img/wind.49f8fc92.jpg";